import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { PartnerRideHistoryReportQuery, PartnerRideHistoryReportQueryVariables } from '@/gql/graphql';

export type FetchPartnerRideHistoryReportInput = PartnerRideHistoryReportQueryVariables;
export type FetchPartnerRideHistoryReportOutput = PartnerRideHistoryReportQuery['partnerRideHistoryReport'];

export const fetchPartnerRideHistoryReport = async (
  input: FetchPartnerRideHistoryReportInput,
  shouldUpdateCache = false,
): Promise<FetchPartnerRideHistoryReportOutput> => {
  const response = await queryExecute({
    query: graphql(`
      query PartnerRideHistoryReport($partnerCodeName: String!, $fromDate: String!, $toDate: String!) {
        partnerRideHistoryReport(partnerCodeName: $partnerCodeName, fromDate: $fromDate, toDate: $toDate) {
          ridesPartnerCredits
          ridesPartnerCost
          activeMembers
          totalMembers
          newMembers
          uniqueRiders
          averageDistance
          averageDuration
          averageRidePartnerCost
          averageRidePartnerCredits
          numberOfCompletedRides
          ridesCustomChargeCost
          ridesCustomChargeCredits
          ytdRidesPartnerCost
          ytdRidesPartnerCredits
          ytdRidesCustomChargeCost
          ytdRidesCustomChargeCredits
        }
      }
    `),
    variables: {
      partnerCodeName: input.partnerCodeName,
      fromDate: input.fromDate,
      toDate: input.toDate,
    },
    ...(shouldUpdateCache ? { fetchPolicy: 'network-only' } : {}),
  });

  return response.data?.partnerRideHistoryReport;
};
